import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const catalogUrl = i18n.language.startsWith('tr')
    ? 'https://can-el.com/common/pdf/canel-katalog-tr.pdf'
    : 'https://can-el.com/common/pdf/canel-katalog-eng.pdf';

  return (
    <footer className="bg-[#111820] py-14">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          <div>
            <div className="flex items-center mb-4">
              <img
                src="https://can-el.com/common/img/canellogo.jpg"
                alt="CAN-EL Logo"
                className="h-8 w-auto object-contain"
              />
            </div>
            <p className="text-white/50 text-sm leading-relaxed">{t('footer_tagline')}</p>
            <div className="flex gap-3 mt-5">
              <a
                href="https://tr.linkedin.com/company/canel-electric"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-[#0A66C2] hover:bg-[#004182] rounded-md transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-white text-base" />
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-4 tracking-wide">{t('footer_services')}</h4>
            {[
              { label: t('services_electrical_title'), href: '/electrical' },
              { label: t('services_construction_title'), href: '/construction' },
            ].map((l) => (
              <a key={l.href} href={l.href} className="block text-white/50 text-sm mb-2 hover:text-[#E8A020] transition-colors cursor-pointer">{l.label}</a>
            ))}
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-4 tracking-wide">{t('footer_company')}</h4>
            {[
              { label: t('footer_about'), href: '/about' },
              { label: t('footer_projects'), href: '/projects' },
              { label: t('footer_catalog'), href: catalogUrl, external: true },
              { label: t('nav_contact'), href: '/contact' },
            ].map((l) => (
              <a
                key={l.label}
                href={l.href}
                {...(l.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                className="block text-white/50 text-sm mb-2 hover:text-[#E8A020] transition-colors cursor-pointer"
              >
                {l.label}
                {l.external && <i className="ri-external-link-line ml-1 text-xs" />}
              </a>
            ))}
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-4 tracking-wide">{t('footer_contact')}</h4>
            <p className="text-white/50 text-sm mb-2 whitespace-pre-line">{t('contact_address_val')}</p>
            <a href="tel:+902122205256" className="block text-white/50 text-sm mb-2 hover:text-[#E8A020] transition-colors">+90 212 220 52 56</a>
            <a href="tel:+905533585024" className="block text-white/50 text-sm mb-2 hover:text-[#E8A020] transition-colors">+90 553 358 50 24</a>
            <a href="mailto:info@can-el.com" className="block text-white/50 text-sm hover:text-[#E8A020] transition-colors">info@can-el.com</a>
          </div>
        </div>
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-white/30 text-xs">{t('footer_copyright')}</p>
          <div className="flex gap-4">
            <a href="#" className="text-white/30 text-xs hover:text-white/60 cursor-pointer">{t('footer_privacy')}</a>
            <a href="#" className="text-white/30 text-xs hover:text-white/60 cursor-pointer">{t('footer_terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}